import { useRef, useState } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { StepTitle, NextButton } from "./fields";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const phoneOk = (p) => (p || "").replace(/\D/g, "").length >= 9;
const emailOk = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e || "");

export const ContactStep = ({ product, answers, contact, setContact, leadId, setLeadId, onSubmit, submitting }) => {
  const [saved, setSaved] = useState(false);
  const saving = useRef(null);
  const update = (k, v) => setContact({ ...contact, [k]: v });

  const savePartial = () => {
    if (!phoneOk(contact.telephone) || saved) return saving.current;
    saving.current = axios.post(`${API}/calc/leads`, { lead_id: leadId, product, answers, contact })
      .then((res) => { setLeadId(res.data.lead_id); setSaved(true); return res.data.lead_id; })
      .catch((e) => { console.error("Lead save error:", e); return null; });
    return saving.current;
  };

  const submit = async () => onSubmit((await saving.current) || leadId);

  const ok = contact.prenom?.trim() && contact.nom?.trim() && phoneOk(contact.telephone) && emailOk(contact.email) && contact.rgpd;

  return (
    <>
      <StepTitle title="Vos coordonnées" subtitle="Pour vous envoyer votre tarif et vous recontacter" />
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-sm mb-1 block">Prénom</Label>
            <Input autoComplete="given-name" value={contact.prenom || ""} onChange={(e) => update("prenom", e.target.value)} className="h-12" data-testid="calc-contact-prenom" />
          </div>
          <div>
            <Label className="text-sm mb-1 block">Nom</Label>
            <Input autoComplete="family-name" value={contact.nom || ""} onChange={(e) => update("nom", e.target.value)} className="h-12" data-testid="calc-contact-nom" />
          </div>
        </div>
        <div>
          <Label className="text-sm mb-1 block">Téléphone</Label>
          <Input type="tel" inputMode="tel" autoComplete="tel" value={contact.telephone || ""} onChange={(e) => { update("telephone", e.target.value); setSaved(false); }}
            onBlur={savePartial} className="h-12" placeholder="06 12 34 56 78" data-testid="calc-contact-telephone" />
        </div>
        <div>
          <Label className="text-sm mb-1 block">Email</Label>
          <Input type="email" inputMode="email" autoComplete="email" value={contact.email || ""} onChange={(e) => update("email", e.target.value)} className="h-12" data-testid="calc-contact-email" />
        </div>
        <label className="flex items-start gap-3 text-sm text-gray-600 cursor-pointer">
          <Checkbox checked={!!contact.rgpd} onCheckedChange={(c) => update("rgpd", !!c)} className="mt-0.5" data-testid="calc-contact-rgpd" />
          <span>J'accepte que JYVIS Assurances utilise mes données pour établir mon devis et me recontacter, conformément au RGPD. *</span>
        </label>
      </div>
      <NextButton disabled={!ok || submitting} onClick={submit} label={submitting ? "Calcul en cours..." : "Voir mon tarif"} />
    </>
  );
};
